// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"280725fd","345":"b98dcc4c","355":"c1dac945","787":"306ee8fa","941":"848d422f"}[chunkId] + ".chunk.js";
};